import type { PortalSellerGroupContext } from './portal.types';

// Contextos que o switcher do sidebar consegue representar: PAY nunca entra
// (tem produto próprio) e "unavailable" só aparece como item desabilitado.
const isSwitchableContext = (context: PortalSellerGroupContext) =>
  context.status !== 'unavailable' && context.profile !== 'PAY';

/**
 * Decide se o sidebar mostra o SELETOR de contexto (um item por seller group)
 * em vez do par toggle LOG/GO + chave de homologação.
 *
 * O modo toggle só funciona quando cada combinação (perfil × ambiente) tem no
 * máximo UM contexto: o toggle escolhe o perfil, a chave escolhe o ambiente, e
 * daí se chega a um único seller group. Basta uma combinação repetida — dois
 * LOG de produção, ou dois LOG de homologação — pra um dos contextos ficar
 * inalcançável pelo painel. Nesse caso cai pro seletor, que lista todos com
 * o badge HML (acesso a homolog pelo seletor, não pela chave).
 *
 * A versão anterior descartava os contextos de homologação ANTES de procurar
 * repetição, então uma conta só com contextos HML (ex.: 2 LOG HML + 1 GO HML)
 * "parecia" ter zero contextos visíveis, caía no toggle e escondia o segundo
 * LOG. O portal mostrava os três cards; o painel só deixava entrar em um.
 */
export const isMultiEnvContexts = (
  contexts: PortalSellerGroupContext[] | undefined,
): boolean => {
  const seen = new Set<string>();

  for (const context of contexts ?? []) {
    if (!isSwitchableContext(context)) continue;

    const key = `${context.profile}:${context.is_homologation ? 'hml' : 'prod'}`;
    if (seen.has(key)) return true;
    seen.add(key);
  }

  return false;
};
